const footerNav = [
  {
    title: '快速导航',
    links: [
      { label: '午夜精选', href: '#carousel' },
      { label: '热门推荐', href: '#cards' },
      { label: '专题合集', href: '#index' },
      { label: '热度榜单', href: '#ranking' },
      { label: '最新动态', href: '#updates' },
    ],
  },
  {
    title: '关于我们',
    links: [
      { label: '平台介绍', href: '#about' },
      { label: '观影优势', href: '#features' },
      { label: '手机看片', href: '#app' },
      { label: '常见问题', href: '#faq' },
      { label: '联系我们', href: '#contact' },
    ],
  },
];

const partners = [
  '合作伙伴', '合作伙伴', '合作伙伴', '合作伙伴', '合作伙伴', '合作伙伴',
];

export default function Footer() {
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const target = document.querySelector(href);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer id="footer" className="bg-background-950 text-background-200">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 pt-14 md:pt-20 pb-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-movie-2-line text-background-50 text-lg"></i>
              </div>
              <span className="font-heading text-xl font-bold text-background-50">
                夜猫电影院
              </span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed mb-4">
              专为夜间追剧打造的高清在线影院。海量片源、秒播不卡、凌晨更新，满足每一个夜猫子的观影需求。深夜不孤单，银幕有温暖。
            </p>
            <div className="flex items-center gap-3">
              <a href="#hero" onClick={(e) => handleNavClick(e, '#hero')} className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 hover:bg-primary-500 text-background-300 hover:text-background-50 transition-colors duration-200">
                <i className="ri-home-line text-sm"></i>
              </a>
              <a href="#contact" onClick={(e) => handleNavClick(e, '#contact')} className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 hover:bg-primary-500 text-background-300 hover:text-background-50 transition-colors duration-200">
                <i className="ri-mail-line text-sm"></i>
              </a>
              <a href="#carousel" onClick={(e) => handleNavClick(e, '#carousel')} className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 hover:bg-primary-500 text-background-300 hover:text-background-50 transition-colors duration-200">
                <i className="ri-star-line text-sm"></i>
              </a>
              <a href="#faq" onClick={(e) => handleNavClick(e, '#faq')} className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 hover:bg-primary-500 text-background-300 hover:text-background-50 transition-colors duration-200">
                <i className="ri-question-line text-sm"></i>
              </a>
            </div>
          </div>

          {footerNav.map((group) => (
            <div key={group.title}>
              <h4 className="text-sm font-semibold text-background-50 mb-4">
                {group.title}
              </h4>
              <ul className="space-y-2.5">
                {group.links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      onClick={(e) => handleNavClick(e, link.href)}
                      className="text-sm text-background-400 hover:text-primary-300 transition-colors duration-200 whitespace-nowrap"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">
              合作伙伴
            </h4>
            <div className="grid grid-cols-3 gap-2">
              {partners.map((name, i) => (
                <div
                  key={i}
                  className="h-10 flex items-center justify-center rounded-lg bg-background-800 text-background-500 text-[10px] font-medium border border-background-700/50"
                >
                  {name}
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="border-t border-background-800 pt-6">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-background-500">
            <p>© 2026 夜猫电影院 版权所有。深夜不孤单，银幕有温暖。</p>
            <div className="flex items-center gap-4">
              <span>夜间追剧</span>
              <span className="w-1 h-1 rounded-full bg-background-600"></span>
              <span>深夜影院</span>
              <span className="w-1 h-1 rounded-full bg-background-600"></span>
              <span>熬夜看剧</span>
              <span className="w-1 h-1 rounded-full bg-background-600"></span>
              <span>免费高清</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}